export const aboutContent = {
  title: '关于我们',
  subtitle: '91n.con 官方入口导航 - 安全高效的访问引导平台',
  brandStory: {
    title: '品牌故事',
    paragraphs: [
      '91n.con 官方入口导航网站诞生于日益增长的用户访问需求。随着网络环境的复杂化，越来越多的用户反映难以找到稳定可靠的官方访问入口。我们深知用户的困扰，因此创建了这个专门的导航平台，致力于为用户提供最准确、最及时、最全面的91n.con访问指引服务。',
      '自上线以来，我们始终坚持以用户需求为导向，持续跟踪官方地址变更，实时更新镜像节点信息，确保每一位访客都能快速找到可用入口。我们的团队由资深网络技术专家和用户体验设计师组成，确保服务既专业又易用。',
      '我们相信，良好的访问体验是优质在线服务的第一步。91n.con官方入口导航不仅仅是一个地址列表，更是用户与优质内容之间的可靠桥梁。',
    ],
  },
  timeline: [
    { year: '2024', event: '91n.con 官方入口导航网站正式上线' },
    { year: '2024 Q2', event: '完成首批5个全球镜像节点的部署与监控' },
    { year: '2024 Q3', event: '上线移动端适配版本，手机访问体验全面优化' },
    { year: '2024 Q4', event: '用户月访问量突破100万' },
    { year: '2025 Q1', event: '启动智能路由推荐系统，自动匹配最优节点' },
    { year: '2025 Q2', event: '新增3个亚洲节点，亚洲地区访问延迟降低40%' },
    { year: '2025 Q3', event: '用户月访问量突破300万，服务可用率达到99.9%' },
    { year: '2025 Q4', event: '上线安全检测功能，实时监控仿冒与钓鱼网站' },
    { year: '2026 Q1', event: '全球节点扩展至50+，覆盖六大洲主要地区' },
    { year: '2026 Q2', event: '平台进行全面技术升级，加载速度提升35%' },
  ],
  reputation: {
    title: '用户口碑',
    items: [
      {
        name: '张先生',
        role: '资深用户',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%20in%20business%20casual%20attire%20against%20clean%20neutral%20background%20with%20soft%20natural%20lighting%20and%20warm%20tones%2C%20headshot%20style&width=120&height=120&seq=avatar-1&orientation=squarish',
        comment: '以前总是找不到正确的入口，自从收藏了这个导航页，再也没有担心过访问问题。地址更新很及时，非常靠谱！',
        rating: 5,
      },
      {
        name: '李女士',
        role: '海外用户',
        avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%20photo%20in%20modern%20smart%20casual%20style%20against%20soft%20neutral%20studio%20background%20with%20gentle%20natural%20lighting%20and%20warm%20tone%2C%20professional%20headshot&width=120&height=120&seq=avatar-2&orientation=squarish',
        comment: '在海外访问国内网站一直很慢，用了这里推荐的海外节点后速度快了很多。感谢网站团队的专业工作！',
        rating: 5,
      },
      {
        name: '王同学',
        role: '学生用户',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%20in%20casual%20style%20with%20friendly%20expression%20against%20clean%20minimal%20background%20with%20soft%20daylight%2C%20headshot%20style&width=120&height=120&seq=avatar-3&orientation=squarish',
        comment: '新手指南写得很详细，按照教程操作很快就搞定了。FAQ也很全面，基本上想问的问题都能找到答案。',
        rating: 5,
      },
      {
        name: '刘先生',
        role: '企业用户',
        avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20male%20business%20portrait%20photo%20in%20formal%20attire%20with%20confident%20expression%20against%20minimal%20light%20gray%20background%20with%20even%20studio%20lighting%2C%20headshot&width=120&height=120&seq=avatar-4&orientation=squarish',
        comment: '作为企业用户，我们非常注重信息安全。这个导航站的安全须知和反钓鱼提示做得很专业，帮助我们团队避免了多次安全风险。',
        rating: 5,
      },
    ],
  },
  contactInfo: {
    title: '联系我们',
    description: '如果您在访问过程中遇到任何问题，或有任何建议和反馈，欢迎通过以下方式联系我们。',
    email: 'support@91n.con',
    responseTime: '工作日24小时内回复',
    tips: '请注意：我们不会通过任何方式索要您的账号密码或个人敏感信息。如遇到此类情况，请勿回复并立即向我们举报。',
  },
};